export const contentTableConfig = {
  title: '证书列表',
  propList: [
    {
      prop: 'name',
      label: '群名',
      minWidth: '200'
    },
    {
      prop: 'owner',
      label: '群主工作账号',
      minWidth: '100'
    },
    {
      prop: 'usedBy',
      label: '群主姓名',
      minWidth: '100'
    }
  ],
  showIndexColumn: false,
  showSelectColumn: false
}
